module.exports = __webpack_public_path__ + "media/fonts/fontawesome-webfont-bfcf94e0.ttf";